export default __webpack_public_path__ + "9696d1f1b0c1d087814c8692302bb336.png";